<div class="chart">
    <app-generic-chart-card 
        [title]="'DASHBOARD.CHARTS.MALE_TEACHER_REPORTS' | translate" 
        [contentTemplate]="activeTeachersContent" 
        [headerTemplate]="headerTemplate" 
        [filterTemplate]="filters"
        [caller]="caller"
        [showReloadButton]="true"
        [showFiltersButton]="true"
        [formGroup]="form"
        [filterSearchKey]="'teacherSearch'">
          <ng-template #headerTemplate let-data>
            <app-chart-card-header-data [headerData]="headerData" [filters]="chartfilters"></app-chart-card-header-data>
          </ng-template>
          <ng-template #activeTeachersContent let-data>
            <app-bar-chart
              [data]="data"
              [showLegend]="data ?? false"
              [legendPosition]="'right'"
              [isStacked]="true"
              [labels]="['DASHBOARD.CHARTS.MALE_TEACHERS' | translate , 'DASHBOARD.CHARTS.FEMALE_TEACHERS' | translate ]">
            </app-bar-chart>
          </ng-template>
          <ng-template #filters>
            <app-date-range
              [label]="'PLACEHOLDERS.DATE' | translate"
              formControlName="dateRange">
            </app-date-range>
          </ng-template>
    </app-generic-chart-card>
  </div>